// In-clinic service grouping over the EXISTING clinic_offers records (no new services).
// Keyword match on the record title; anything unmatched falls into General Wellness.
export const ASSESSMENT_KEYS = ["investigation", "microscopic"];

export const DIRECTED_TREATMENTS = {
  title: "Practitioner-Directed Trichology Treatments",
  copy: "These scalp-care modalities are used only when appropriate after a professional hair & scalp assessment, any required safety screening and consent, and — when warranted — medical referral. They may be included within an individualized trichology program and are scheduled by our team, not booked independently.",
  items: ["High Frequency scalp therapy", "Low-Level Light Therapy (LLLT)", "Scalp microneedling", "Scalp detoxification & rejuvenation", "Herbal infusion scalp therapy"],
  ctaLabel: "Start With a Hair & Scalp Assessment",
  ctaTo: "/hair-scalp#assessments",
};

// Existing-client category notes (owner-provided scope for each existing record).
export const EXISTING_DETAILS = {
  "healthy hair maintenance": ["Haircuts and trims", "Tapered cuts", "Pixie cuts", "Relaxer and silk press services", "Limited existing hair and color maintenance"],
  "loc services": ["Existing loc maintenance and services"],
  "alopecia camouflage": ["Existing non-extension camouflage and maintenance services"],
  "wax services": ["Existing waxing services"],
};

export const HSA_NOTE = "HSA/FSA cards accepted for eligible services. Eligibility varies by plan and service.";

export function splitClinical(offers) {
  const isAssessment = (o) => ASSESSMENT_KEYS.some((k) => (o.title || "").toLowerCase().includes(k));
  return {
    assessments: offers.filter(isAssessment),
    wellness: offers.filter((o) => !isAssessment(o)),
  };
}

export function existingDetails(title) {
  const t = (title || "").toLowerCase();
  const key = Object.keys(EXISTING_DETAILS).find((k) => t.includes(k));
  return key ? EXISTING_DETAILS[key] : [];
}
